import { Main } from 'Shared/PageLayout';
import Description from '../ProductRawMaterialDescription';
import Information from '../ProductRawMaterialInformation';
import AvailabilityTable from '../ProductRawMaterialAvailabilityTable';
import React from 'react';
import * as styles from './base.scss';
export default class ProductRawMaterialGuide extends React.Component {
    render() {
        return (React.createElement("div", { className: styles.RawWrapper },
            React.createElement(Main, { className: styles.main },
                React.createElement("div", { className: styles.RawBody },
                    React.createElement(Description, Object.assign({}, this.props)),
                    React.createElement(Information, Object.assign({}, this.props)),
                    React.createElement(AvailabilityTable, Object.assign({}, this.props))))));
    }
}
